import { createDraftSafeSelector } from '@reduxjs/toolkit'

const selectTutor = (state) => state.tutor

const tutorSelector = createDraftSafeSelector(selectTutor, (tutor) => tutor)
export const tutorSelectorById = createDraftSafeSelector(
  selectTutor,
  (_, tutorId) => tutorId,
  (tutor, tutorId) => {
    let filteredTutor = tutor?.registeredTutors?.filter((tutorRegistered) => {
      return tutorRegistered.id === tutorId
    })

    // this will return only single tutor
    if (filteredTutor && filteredTutor.length > 0) {
      return filteredTutor[0]
    } else return []
  },
)

export default tutorSelector
